import * as React from 'react';

export interface SidebarHeaderProps {
  /** A custom node to render from the bottom */
  children?: React.ReactNode;
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** A text to show as the header title */
  title?: React.ReactNode;
  /** A text to show as the header subtitle */
  subtitle?: React.ReactNode;
}

export class SidebarHeader extends React.PureComponent<SidebarHeaderProps> {}
